import { render, staticRenderFns } from "./KitchenSinkContainer.vue?vue&type=template&id=f9bb4b18"
import script from "./KitchenSinkContainer.vue?vue&type=script&lang=js"
export * from "./KitchenSinkContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports